import CloseIcon from '@mui/icons-material/Close';
import { Dialog,DialogContent,DialogTitle,IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { trackEventMatomo } from "../../../helpers/matomo";
import SingleNotification from "../SingleNotification";

export default function ModalTicket({
  id, mutate, openModal, setOpenModal, requesterMode = false }:
  { id?: string | null, mutate: Function, openModal: boolean, setOpenModal: Function, requesterMode?: boolean }) {
  const { t } = useTranslation("translation");
  const [actionPending, setActionPending] = useState(false);
  const handleActionPending = useCallback((pending: boolean) => setActionPending(pending), []);


  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={openModal}
      onClose={() => {
        if (actionPending) return;
        trackEventMatomo('modal chamado', 'click', 'button', 'fecha/cancela');
        setOpenModal(false);
      }}
      scroll={'paper'}
    >
      <IconButton
        disabled={actionPending}
        onClick={() => {
          if (actionPending) return;
          trackEventMatomo('modal chamado', 'click', 'button', 'fecha/cancela');
          setOpenModal(false);
        }}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle >{t("notifications.ticket.ticket")}: {id ?? ''}</DialogTitle >
      <DialogContent dividers={true}>
        <SingleNotification
          idModal={id as string}
          mutate={mutate}
          requesterMode={requesterMode}
          onActionPendingChange={handleActionPending}
        />
      </DialogContent>
    </Dialog>
  );
}